// Lightweight coordinator between the planned-outage "prior" API response and
// the axios response interceptor. When any authenticated API responds and the
// current time has crossed the announced outage start, the active-outage
// request is fired exactly once.

let outageStartMs = NaN;
let hasTriggered = false;
let triggerActiveOutage = null;

export const parseUtcToEpochMs = (value) => {
  if (!value) return NaN;
  const hasTimezone = /Z$|[+-]\d{2}:?\d{2}$/.test(value);
  const isoValue = hasTimezone ? value : `${value}Z`;
  return new Date(isoValue).getTime();
};

export const configureOutageMonitor = ({ startsUtc, onOutageStart } = {}) => {
  const nextStartMs = parseUtcToEpochMs(startsUtc);
  if (nextStartMs !== outageStartMs) {
    hasTriggered = false;
  }
  outageStartMs = nextStartMs;
  triggerActiveOutage = typeof onOutageStart === "function" ? onOutageStart : null;
};

export const resetOutageMonitor = () => {
  outageStartMs = NaN;
  hasTriggered = false;
  triggerActiveOutage = null;
};

export const checkOutageWindow = () => {
  if (hasTriggered) return;
  if (!Number.isFinite(outageStartMs)) return;
  if (!triggerActiveOutage) return;
  if (Date.now() < outageStartMs) return;
  hasTriggered = true;
  try {
    triggerActiveOutage();
  } catch (_) {
    // swallow to avoid breaking the axios pipeline
  }
};
